<template>
    <loading 
        :active="loadingValue"
        :can-cancel="false"
        :is-full-page="fullPage"
        loader-color="#42b983"
        @update:active="$emit('update:loading', $event)"
    >
      <template #default="{ loader }">
        <div class="custom-loader">
          <NetplusLogo ref="netplusLogo" :animate="loadingValue"></NetplusLogo>
          <h4>{{ mensajeLoading }}</h4>
        </div>
      </template>
    </loading>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import NetplusLogo from './WidgetNetplusLogo.vue'
export default {
    components: {
        Loading,
        NetplusLogo
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        fullPage: {
            type: Boolean,
            default: true
        },
        mensajeLoading: {
            type: String,
            default: "Cargando..."
        }
    },
    methods: {

    },
    computed: {
        loadingValue: {
            get() {
              return this.loading;
            },
            set(value) {
                console.log(value)
                this.$emit('update:loading', value);
            }
        }
    }
}
</script>
<style>
.custom-loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>